module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "pl-3-2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Editor: Lee M. Jonsson")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Technical Editor: Diana Roberts")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Copy Editor: Judith M. Moretz")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Illustrations: Gretchen Schwarzenbach, GNS Graphics, and John M. Cram")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Cover design: John M. Cram and Kathy Lee")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Book design: John M. Cram and Diane Pedersen")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Photography: Sharon Risedorph Photography, San Francisco, California;")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Cevin Brent Smith Photography, Raleigh, North Carolina; and")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Jim Egan Photography, Providence, Rhode Island")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Interior mill shots: Cotton Incorporated, Raleigh, North Carolina, Cranston")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Print Works Company, Webster, Massachusetts, and Pendleton Woolen Mills, Portland, Oregon")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Author photo: James Koch")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Photographs in Chapter 8, 9, 13, and all chapter openers by Sharon")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Risedorph. Photographs in Chapters 3 and 6 by Cevin Brent Smith unless")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("otherwise noted. Photographs in Chapters 4 and 7 by Jim Egan unless")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("otherwise noted. Photographs in Chapter 5 by Pendleton Woolen Mills.")]), _vm._v(" "), _c('p', {
    staticClass: "textstyle3"
  }, [_vm._v("Photographs in Chapter 12 by Harriet Hargrave.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1117ebab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_copyrighttitle.vue
// module id = 60
// module chunks = 0